"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const material_1 = require("@mui/material");
// import app components
const colors_1 = __importDefault(require("../../../theme/colors"));
const tooltip_1 = __importDefault(require("../../elements/tooltip"));
const Input = (props) => {
    const { type = "text", disabled = false, required = false, label, placeholder, helperText, multiline, fullWidth, error = false, value, rows = 3, startIcon, endIcon, endIcons, onChange, onClick, sx = {}, ...rest } = props;
    const inputProps = { startAdornment: null, endAdornment: null };
    if (endIcon) {
        // TODO: Deprecation warning: 'endIcon' and 'onClick' will be deprecated in pd-theme/5.0.0. Please use endIcons prop instead.
        inputProps.endAdornment = (react_1.default.createElement(material_1.InputAdornment, { position: "end" },
            react_1.default.createElement(material_1.IconButton, { onClick: onClick, sx: { color: colors_1.default.icons[700], fontSize: "1rem" } }, endIcon)));
    }
    else if (endIcons && endIcons.length > 0) {
        inputProps.endAdornment = (react_1.default.createElement(material_1.Stack, { direction: "row", spacing: 1 }, endIcons
            .filter((endIcon) => endIcon.icon && endIcon.onClick)
            .map(({ icon, tooltip, onClick }, actionsIndex) => {
            const button = (react_1.default.createElement(material_1.IconButton, { onClick: (e) => {
                    e.stopPropagation();
                    onClick(icon);
                }, size: "small", sx: { fontSize: "0.9rem", color: colors_1.default.icons[700] } }, icon));
            return (react_1.default.createElement(react_1.Fragment, { key: actionsIndex }, tooltip ? react_1.default.createElement(tooltip_1.default, { title: tooltip }, button) : button));
        })));
    }
    if (startIcon) {
        inputProps.startAdornment = (react_1.default.createElement(material_1.InputAdornment, { position: "start", sx: { zIndex: 1, fontSize: "1rem" } }, startIcon));
    }
    return (react_1.default.createElement(material_1.TextField, { type: type, label: label, variant: "standard", placeholder: placeholder, value: value, onChange: onChange, error: !!error, helperText: helperText, required: required, disabled: disabled, InputProps: { disableUnderline: true, ...inputProps }, InputLabelProps: { shrink: true }, multiline: multiline, rows: rows, fullWidth: fullWidth, sx: { display: type === "hidden" ? "none" : "initial", ...sx }, ...rest }));
};
exports.default = Input;
